import { SVG, SVGProps } from './svg'

export function IconArrowUpShort(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M11.5 21a.5.5 0 0 1-.5-.5V6.33l-6.44 6.45a.5.5 0 0 1-.71 0l-.7-.71a.5.5 0 0 1 0-.71l8.13-8.14a.75.75 0 0 1 .53-.22h.38c.2 0 .39.08.53.22l8.13 8.14a.5.5 0 0 1 0 .71l-.71.71a.49.49 0 0 1-.7 0L13 6.33V20.5a.5.5 0 0 1-.5.5h-1Z" />
    </SVG>
  )
}
